import React from "react";
import GlowingOrb from "../ui/GlowingOrb";

const ModalLoadingState = ({ handleClose, handlePublishEvent }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white justify-center p-8 rounded-2xl shadow-lg">
        <div className="flex justify-center">
          <GlowingOrb size="lg" />
        </div>
      </div>
    </div>
  );
};

export default ModalLoadingState;
